export default "__VITE_ASSET__Bgcr9si3__"